import { createContext, useContext, useState, useEffect } from "react";

const dict = {
  es: {
    appName: "Dr. Dimy Laguerre",
    tagline: "Consulta médica con receta electrónica",
    heroTitle: "Atención médica humana, recetas digitales seguras",
    heroSub: "Reserva tu consulta con el Dr. Dimy Laguerre, recibe tu receta electrónica y accede a tu historial clínico desde cualquier lugar del mundo.",
    cta_book: "Reservar consulta",
    cta_login: "Iniciar sesión",
    cta_start: "Comenzar ahora",
    feature1_t: "Agenda 24/7",
    feature1_d: "Lunes a domingo, slots de 10–15 min ajustables a tu ritmo.",
    feature2_t: "Historia clínica",
    feature2_d: "Toda tu información médica organizada y accesible.",
    feature3_t: "Receta electrónica",
    feature3_d: "Compatible con REMPE, PDF firmado y QR de verificación.",
    feature4_t: "Pago Wise",
    feature4_d: "Paga de forma segura desde cualquier país con Wise.",
    login: "Iniciar sesión",
    register: "Registrarse",
    email: "Correo electrónico",
    password: "Contraseña",
    name: "Nombre completo",
    or: "o",
    googleLogin: "Continuar con Google",
    logout: "Cerrar sesión",
    dashboard: "Panel",
    appointments: "Citas",
    history: "Historia clínica",
    prescriptions: "Recetas",
    users: "Usuarios",
    availability: "Mi disponibilidad",
    settings: "Ajustes",
    new_appointment: "Reservar cita",
    new_prescription: "Nueva receta",
    doctor: "Médico",
    patient: "Paciente",
    date: "Fecha",
    time: "Hora",
    reason: "Motivo de consulta",
    mode: "Modalidad",
    in_person: "Presencial",
    video: "Videoconsulta",
    join_video: "Unirse",
    status: "Estado",
    scheduled: "Programada",
    completed: "Completada",
    cancelled: "Cancelada",
    diagnosis: "Diagnóstico",
    medications: "Medicamentos",
    medication: "Medicamento",
    dosage: "Dosis",
    frequency: "Frecuencia",
    duration: "Duración",
    instructions: "Instrucciones",
    notes: "Notas",
    add: "Agregar",
    save: "Guardar",
    cancel: "Cancelar",
    download_pdf: "Descargar PDF",
    welcome: "Bienvenido",
    today: "Hoy",
    upcoming: "Próximas",
    no_data: "Sin registros",
    ai_assist: "Asistente IA",
    symptoms: "Síntomas",
    age: "Edad",
    gender: "Sexo",
    suggest: "Sugerir",
    code: "Código",
    add_history: "Agregar entrada",
    title: "Título",
    content: "Contenido",
    type: "Tipo",
    consultation: "Consulta",
    lab: "Laboratorio",
    note: "Nota",
    allergy: "Alergia",
    delete: "Eliminar",
    confirm: "Confirmar",
    select_patient: "Seleccionar paciente",
    select_doctor: "Seleccionar médico",
    saved: "Guardado correctamente",
    error_generic: "Ocurrió un error",
    legal: "Esta receta cumple con el formato REMPE. Verifique el código de seguridad.",
    select_date: "Selecciona fecha",
    available_slots: "Horarios disponibles",
    no_slots: "No hay horarios disponibles este día",
    book_slot: "Reservar este horario",
    weekly_schedule: "Horario semanal",
    slot_duration: "Duración del slot",
    minutes: "minutos",
    blocked_dates: "Fechas bloqueadas",
    add_blocked: "Bloquear fecha",
    enabled: "Activo",
    monday: "Lunes",
    tuesday: "Martes",
    wednesday: "Miércoles",
    thursday: "Jueves",
    friday: "Viernes",
    saturday: "Sábado",
    sunday: "Domingo",
    payment: "Pago",
    pay_with_wise: "Pagar 20€ con Wise",
    payment_pending: "Pago pendiente",
    payment_paid: "Pagado",
    payment_refunded: "Reembolsado",
    mark_paid: "Marcar pagado",
    mark_pending: "Marcar pendiente",
    notify_whatsapp: "Avisar al doctor por WhatsApp",
    booking_confirmed: "¡Cita confirmada!",
    booking_confirmed_sub: "Notifica al doctor por WhatsApp y completa tu pago.",
    license_number: "Nº de colegiado",
    rempe_code: "Código REMPE",
    college: "Colegio de Médicos",
    region: "Comunidad Autónoma",
    nif: "DNI/NIE",
    profile: "Perfil profesional",
    save_profile: "Guardar perfil",
    income_month: "Ingresos del mes",
    pending_payments: "Pagos pendientes",
    valid_until: "Válida hasta",
    verification: "Verificación",
    exams: "Exámenes",
    new_exam: "Nueva petición de examen",
    exam_lab: "Laboratorio",
    exam_imaging: "Imagen",
    urgency: "Prioridad",
    routine: "Rutina",
    preferent: "Preferente",
    urgent: "Urgente",
    clinical_info: "Información clínica",
    add_test: "Agregar prueba",
    custom_test: "Otra prueba (escribir)",
    messages: "Mensajes",
    send: "Enviar",
    type_message: "Escribe un mensaje...",
    no_messages: "Sin conversaciones",
    services_title: "Servicios médicos que brindo",
    services_subtitle: "Atención integral, ética y centrada en ti",
    svc1_t: "Diagnóstico y tratamiento",
    svc1_d: "De enfermedades comunes con enfoque clínico riguroso.",
    svc2_t: "Recetas y prescripciones",
    svc2_d: "Gestión electrónica de tus medicamentos y renovaciones.",
    svc3_t: "Patologías crónicas",
    svc3_d: "Seguimiento personalizado de diabetes, hipertensión, asma y más.",
    svc4_t: "Interpretación clínica",
    svc4_d: "Resolución de dudas y revisión de tus pruebas e informes.",
    svc5_t: "Prevención y asesoramiento",
    svc5_d: "Hábitos saludables, vacunación y check-ups personalizados.",
    svc6_t: "Documentos médicos",
    svc6_d: "Justificantes, informes, certificados y bajas laborales.",
    svc7_t: "Triaje y derivación",
    svc7_d: "Evaluación inicial y derivación al especialista adecuado.",
  },
  fr: {
    appName: "Dr. Dimy Laguerre",
    tagline: "Consultation médicale avec ordonnance électronique",
    heroTitle: "Soins humains, ordonnances numériques sécurisées",
    heroSub: "Prenez rendez-vous avec le Dr. Dimy Laguerre, recevez votre ordonnance électronique et accédez à votre dossier depuis partout dans le monde.",
    cta_book: "Réserver", cta_login: "Se connecter", cta_start: "Commencer",
    feature1_t: "Agenda 7j/7", feature1_d: "Du lundi au dimanche, créneaux de 10–15 min.",
    feature2_t: "Dossier médical", feature2_d: "Toute votre information médicale organisée.",
    feature3_t: "Ordonnance électronique", feature3_d: "Compatible REMPE, PDF signé avec QR.",
    feature4_t: "Paiement Wise", feature4_d: "Payez en toute sécurité depuis n'importe quel pays avec Wise.",
    login: "Connexion", register: "Inscription",
    email: "Email", password: "Mot de passe", name: "Nom complet",
    or: "ou", googleLogin: "Continuer avec Google", logout: "Déconnexion",
    dashboard: "Tableau de bord", appointments: "Rendez-vous", history: "Dossier médical",
    prescriptions: "Ordonnances", users: "Utilisateurs",
    availability: "Ma disponibilité", settings: "Paramètres",
    new_appointment: "Réserver", new_prescription: "Nouvelle ordonnance",
    doctor: "Médecin", patient: "Patient",
    date: "Date", time: "Heure", reason: "Motif", mode: "Mode",
    in_person: "En personne", video: "Vidéo", join_video: "Rejoindre", status: "Statut",
    scheduled: "Planifié", completed: "Terminé", cancelled: "Annulé",
    diagnosis: "Diagnostic", medications: "Médicaments", medication: "Médicament",
    dosage: "Dosage", frequency: "Fréquence", duration: "Durée", instructions: "Instructions",
    notes: "Notes", add: "Ajouter", save: "Enregistrer", cancel: "Annuler",
    download_pdf: "Télécharger PDF", welcome: "Bienvenue", today: "Aujourd'hui", upcoming: "À venir",
    no_data: "Aucun enregistrement", ai_assist: "Assistant IA", symptoms: "Symptômes",
    age: "Âge", gender: "Sexe", suggest: "Suggérer", code: "Code",
    add_history: "Ajouter", title: "Titre", content: "Contenu", type: "Type",
    consultation: "Consultation", lab: "Labo", note: "Note", allergy: "Allergie",
    delete: "Supprimer", confirm: "Confirmer", select_patient: "Sélectionner patient",
    select_doctor: "Sélectionner médecin", saved: "Enregistré", error_generic: "Une erreur est survenue",
    legal: "Cette ordonnance respecte le format REMPE. Vérifiez le code.",
    select_date: "Sélectionnez une date", available_slots: "Créneaux disponibles",
    no_slots: "Aucun créneau ce jour", book_slot: "Réserver ce créneau",
    weekly_schedule: "Horaire hebdomadaire", slot_duration: "Durée du créneau", minutes: "minutes",
    blocked_dates: "Dates bloquées", add_blocked: "Bloquer une date", enabled: "Actif",
    monday: "Lundi", tuesday: "Mardi", wednesday: "Mercredi", thursday: "Jeudi",
    friday: "Vendredi", saturday: "Samedi", sunday: "Dimanche",
    payment: "Paiement", pay_with_wise: "Payer 20€ avec Wise",
    payment_pending: "Paiement en attente", payment_paid: "Payé", payment_refunded: "Remboursé",
    mark_paid: "Marquer payé", mark_pending: "Marquer en attente",
    notify_whatsapp: "Prévenir le docteur sur WhatsApp",
    booking_confirmed: "Rendez-vous confirmé!",
    booking_confirmed_sub: "Prévenez le docteur sur WhatsApp et complétez votre paiement.",
    license_number: "Nº d'ordre", rempe_code: "Code REMPE", college: "Conseil de l'Ordre",
    region: "Région", nif: "Pièce d'identité",
    profile: "Profil professionnel", save_profile: "Enregistrer profil",
    income_month: "Revenus du mois", pending_payments: "Paiements en attente",
    valid_until: "Valable jusqu'au", verification: "Vérification",
    exams: "Examens", new_exam: "Nouvelle demande d'examen",
    exam_lab: "Laboratoire", exam_imaging: "Imagerie",
    urgency: "Priorité", routine: "Routine", preferent: "Préférent", urgent: "Urgent",
    clinical_info: "Information clinique", add_test: "Ajouter examen", custom_test: "Autre examen",
    messages: "Messages", send: "Envoyer", type_message: "Écris un message...", no_messages: "Aucune conversation",
    services_title: "Services médicaux que je propose",
    services_subtitle: "Soins complets, éthiques, centrés sur vous",
    svc1_t: "Diagnostic et traitement", svc1_d: "Maladies courantes avec rigueur clinique.",
    svc2_t: "Ordonnances", svc2_d: "Gestion électronique de vos médicaments et renouvellements.",
    svc3_t: "Maladies chroniques", svc3_d: "Suivi personnalisé du diabète, HTA, asthme...",
    svc4_t: "Interprétation clinique", svc4_d: "Réponses à vos questions et révision de vos examens.",
    svc5_t: "Prévention et conseils", svc5_d: "Habitudes saines, vaccination, check-ups.",
    svc6_t: "Documents médicaux", svc6_d: "Justificatifs, rapports, certificats, arrêts maladie.",
    svc7_t: "Triage et orientation", svc7_d: "Évaluation initiale et orientation vers le spécialiste.",
  },
  ht: {
    appName: "Dr. Dimy Laguerre",
    tagline: "Konsiltasyon medikal ak preskripsyon elektwonik",
    heroTitle: "Swen imen, preskripsyon dijital ki an sekirite",
    heroSub: "Pran randevou ou avèk Dr. Dimy Laguerre, resevwa preskripsyon elektwonik ou epi gade dosye medikal ou kèlkeswa kote w ye nan mond lan.",
    cta_book: "Pran randevou", cta_login: "Konekte", cta_start: "Kòmanse",
    feature1_t: "Ajenda 7 jou", feature1_d: "Lendi rive dimanch, espas 10–15 min.",
    feature2_t: "Dosye medikal", feature2_d: "Tout enfòmasyon ou òganize epi disponib.",
    feature3_t: "Preskripsyon elektwonik", feature3_d: "Konfòm REMPE, PDF siyen ak QR.",
    feature4_t: "Peman Wise", feature4_d: "Peye an sekirite depi nenpòt peyi avèk Wise.",
    login: "Konekte", register: "Anrejistre",
    email: "Imèl", password: "Modpas", name: "Non konplè",
    or: "oswa", googleLogin: "Kontinye ak Google", logout: "Dekonekte",
    dashboard: "Tablodbò", appointments: "Randevou", history: "Dosye medikal",
    prescriptions: "Preskripsyon", users: "Itilizatè",
    availability: "Disponibilite mwen", settings: "Paramèt",
    new_appointment: "Pran randevou", new_prescription: "Nouvo preskripsyon",
    doctor: "Doktè", patient: "Pasyan",
    date: "Dat", time: "Lè", reason: "Rezon", mode: "Modalite",
    in_person: "An pèsòn", video: "Videyo", join_video: "Antre", status: "Estati",
    scheduled: "Planifye", completed: "Fini", cancelled: "Anile",
    diagnosis: "Dyagnostik", medications: "Medikaman", medication: "Medikaman",
    dosage: "Doz", frequency: "Frekans", duration: "Dire", instructions: "Enstriksyon",
    notes: "Nòt", add: "Ajoute", save: "Anrejistre", cancel: "Anile",
    download_pdf: "Telechaje PDF", welcome: "Byenveni", today: "Jodi a", upcoming: "Pwochen yo",
    no_data: "Pa gen anyen", ai_assist: "Asistan IA", symptoms: "Sentòm",
    age: "Laj", gender: "Sèks", suggest: "Sigjere", code: "Kòd",
    add_history: "Ajoute antre", title: "Tit", content: "Kontni", type: "Kalite",
    consultation: "Konsiltasyon", lab: "Laboratwa", note: "Nòt", allergy: "Alèji",
    delete: "Efase", confirm: "Konfime", select_patient: "Chwazi pasyan",
    select_doctor: "Chwazi doktè", saved: "Anrejistre", error_generic: "Te gen yon erè",
    legal: "Preskripsyon sa a konfòme ak fòma REMPE. Verifye kòd sekirite a.",
    select_date: "Chwazi dat la", available_slots: "Lè ki disponib",
    no_slots: "Pa gen lè disponib jou sa", book_slot: "Reserve lè sa a",
    weekly_schedule: "Orè chak semèn", slot_duration: "Dire chak espas", minutes: "minit",
    blocked_dates: "Dat bloke", add_blocked: "Bloke yon dat", enabled: "Aktif",
    monday: "Lendi", tuesday: "Madi", wednesday: "Mèkredi", thursday: "Jedi",
    friday: "Vandredi", saturday: "Samdi", sunday: "Dimanch",
    payment: "Peman", pay_with_wise: "Peye 20€ ak Wise",
    payment_pending: "Peman annatant", payment_paid: "Peye", payment_refunded: "Ranbouse",
    mark_paid: "Make peye", mark_pending: "Make annatant",
    notify_whatsapp: "Avize doktè a sou WhatsApp",
    booking_confirmed: "Randevou konfime!",
    booking_confirmed_sub: "Avize doktè a sou WhatsApp epi konplete peman ou.",
    license_number: "Nimewo lisans", rempe_code: "Kòd REMPE", college: "Òd Doktè yo",
    region: "Rejyon", nif: "Idantifyan",
    profile: "Pwofil pwofesyonèl", save_profile: "Anrejistre pwofil",
    income_month: "Revni mwa a", pending_payments: "Peman annatant",
    valid_until: "Valab jiska", verification: "Verifikasyon",
    exams: "Egzamen", new_exam: "Nouvo demann egzamen",
    exam_lab: "Laboratwa", exam_imaging: "Imajri",
    urgency: "Priyorite", routine: "Woutin", preferent: "Preferans", urgent: "Ijans",
    clinical_info: "Enfòmasyon klinik", add_test: "Ajoute tès", custom_test: "Lòt tès",
    messages: "Mesaj", send: "Voye", type_message: "Ekri yon mesaj...", no_messages: "Pa gen konvèsasyon",
    services_title: "Sèvis medikal mwen ofri",
    services_subtitle: "Swen konplè, etik, santre sou ou",
    svc1_t: "Dyagnostik ak tretman", svc1_d: "Maladi komen avèk apwòch klinik rigourèz.",
    svc2_t: "Preskripsyon", svc2_d: "Jesyon elektwonik medikaman w ak renouvèlman.",
    svc3_t: "Maladi kwonik", svc3_d: "Swivi pèsonalize dyabèt, tansyon, opresyon, elatriye.",
    svc4_t: "Entèpretasyon klinik", svc4_d: "Repons sou kesyon w ak revizyon egzamen w.",
    svc5_t: "Prevansyon ak konsèy", svc5_d: "Bon abitid, vaksen ak chek-up.",
    svc6_t: "Dokiman medikal", svc6_d: "Jistifikatif, rapò, sètifika, konje maladi.",
    svc7_t: "Triaj ak referans", svc7_d: "Evalyasyon inisyal ak referans bay espesyalis.",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");
  useEffect(() => { localStorage.setItem("lang", lang); }, [lang]);
  const t = (k) => (dict[lang] && dict[lang][k]) || dict.es[k] || k;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
export const LANGS = [
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "ht", label: "Kreyòl Ayisyen" },
];
